<script setup>
import { AUSTRALIA_COUNTRY_NAME } from '@/constants';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
    site: {
        type: Object,
        required: true,
    },
    course: {
        type: Object,
        required: true,
    }
});

const page = usePage();
const context = computed(() => page.props?.context);
const enquiryEnabled = context.value?.enquiry_enabled ?? false;

const auDollarFormatter = (dollars) => `AUD $${Intl.NumberFormat().format(dollars)}`;
</script>

<template>
    <div>
        <div class="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-4 mb-1 mt-3">
            <div>
                <p>
                    <strong>CRICOS Code:</strong> {{ site.cricos_code }}
                </p>
                <p v-if="site.course_start_date" class="mb-1 mt-3">
                    <strong>Start date:</strong> {{ site.course_start_date }}
                </p>
                <p class="mb-1 mt-3">
                    <strong>Address</strong>
                </p>
                <p>{{ site.name }}</p>
                <p>{{ site.street1 }}</p>
                <p>{{ [site.suburb, site.state_name_full, site.postcode].filter((v) => !!v).join(', ') }}</p>
                <p v-if="site.country.name != AUSTRALIA_COUNTRY_NAME">{{ site.country.name }}</p>
                <p v-if="site.attendance.length" class="mb-1 mt-3" >
                    <strong>Attendance options</strong>
                </p>
                <ul v-if="site.attendance.length">
                    <li
                        v-for="(attendance, attIndex) in site.attendance"
                        :key="`attendance-${attIndex}`"
                        class="mb-0 h-fit"
                    >
                        <p>{{ attendance.name }} - {{ attendance["length"] }} {{ attendance.du_name_plural }}</p>
                    </li>
                </ul>
                <p class="mb-1 mt-3">
                    <strong>Total tuition costs</strong>
                </p>
                <p v-if="site.fees.overseas_full_fee">
                    {{ auDollarFormatter(site.fees.overseas_full_fee) }}
                </p>
                <a 
                    v-else-if="enquiryEnabled" class="underline"
                    :aria-label="`Enquire about ${course.name}`"
                    :href="`/course/${course.slug}/${course.id}/enquiry`"
                >Enquire</a>
            </div>
            <div v-if="site.overall_toefl_score || site.overall_ielts_score">
                <p class="mb-3">
                    <strong class="underline">ENTRY CRITERIA*</strong>
                </p>
                <p v-if="site.overall_toefl_score">
                    <strong>TOEFL:</strong> {{site.overall_toefl_score}}
                </p>
                <p v-if="site.overall_ielts_score">
                    <strong>OVERALL IELTS:</strong> {{site.overall_ielts_score}}
                </p>
            </div>
        </div>
        <hr class="w-full my-6">
    </div>
</template>

